import { Card, CardBody, CardText } from 'reactstrap';
import { formatDesiredStartDate } from '../../../helpers/pendingEnrollment';

type PendingEnrollmentNoticeProps = {
  kidStatus?: string | null;
  potentialDate?: string | null;
};

const PendingEnrollmentNotice = ({ kidStatus, potentialDate }: PendingEnrollmentNoticeProps) => {
  const desiredStartDate = formatDesiredStartDate(potentialDate);
  const title = kidStatus === 'DENIED' ? 'This enrollment was denied.' : 'This web enrollment is waiting for approval.';

  return (
    <Card className="mb-4" style={{ backgroundColor: '#FFF4D6' }}>
      <CardBody>
        <CardText tag="div">
          <strong>{title}</strong>
          {desiredStartDate ? (
            <div>
              Desired start date: <strong>{desiredStartDate}</strong>
            </div>
          ) : null}
          <div>
            To enroll the child, choose the class, the status (Enrolled or Enrolled but not started) and the start date,
            then save.
          </div>
        </CardText>
      </CardBody>
    </Card>
  );
};

export default PendingEnrollmentNotice;
